import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M16.627 1.828a1.998 1.998 0 0 1 2.829 0L30.77 13.142a1.998 1.998 0 0 1 0 2.829 1.998 1.998 0 0 1-2.829 0l-1.304-1.304-6.045 7.053a10.502 10.502 0 0 1-.672 7.699l-.089.177a1.988 1.988 0 0 1-1.467 1.078 2.01 2.01 0 0 1-1.737-.561L2.485 15.97a2.002 2.002 0 0 1-.561-1.736 1.975 1.975 0 0 1 1.078-1.467l.177-.089a10.502 10.502 0 0 1 7.699-.672l7.053-6.045-1.304-1.304a1.998 1.998 0 0 1 0-2.829Zm-9.9 21.214 2.83 2.828-4.243 4.243a1.998 1.998 0 0 1-2.829 0 1.998 1.998 0 0 1 0-2.829l4.243-4.242Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h32v32H0z"
		})
	}) })]
});
export default SvgPin;
